import React from 'react';
import {
  Table,
} from 'reactstrap';

export const VolLocTimeEruptModal = {
  title: 'Time Erupt',
  body: (
    <div>
      <p>
        The date of the last known eruption (from the Smithsonian Institution, Global Volcanism Program)
      </p>
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">D1</th>
            <td>Last known eruption 1964 or later</td>
          </tr>
          <tr>
            <th scope="row">D2</th>
            <td>Last known eruption 1900-1963</td>
          </tr>
          <tr>
            <th scope="row">D3</th>
            <td>Last known eruption 1800-1899</td>
          </tr>
          <tr>
            <th scope="row">D4</th>
            <td>Last known eruption 1700-1799</td>
          </tr>
          <tr>
            <th scope="row">D5</th>
            <td>Last known eruption 1500-1699</td>
          </tr>
          <tr>
            <th scope="row">D6</th>
            <td>Last known eruption A.D. 1-1499</td>
          </tr>
          <tr>
            <th scope="row">D7</th>
            <td>Last known eruption B.C. (Holocene)</td>
          </tr>
          <tr>
            <th scope="row">U</th>
            <td>Undated, but probable Holocene eruption</td>
          </tr>
          <tr>
            <th scope="row">Q</th>
            <td>Quaternary eruption(s) with the only known Holocene activity being hydrothermal</td>
          </tr>
          <tr>
            <th scope="row">?</th>
            <td>Uncertain Holocene eruption</td>
          </tr>
        </tbody>
      </Table>
    </div>
  ),
};
